/**
 * `/ayuda/imprimir`: `pagina` prints one page of the manual instead of all of it
 * (`?pagina=primeros-pasos`, `?pagina=referencia/plataforma`), and `imprimir` opens the browser's
 * print dialog as soon as the manual and its screenshots are on screen (the button of `/ayuda`
 * sends it; the program that saves the PDF does not, it prints by itself).
 */
export interface HelpPrintSearch {
  pagina?: string;
  imprimir?: boolean;
}

export function helpPrintSearchSchema(search: Record<string, unknown>): HelpPrintSearch {
  const pagina = search['pagina'];
  const imprimir = search['imprimir'];
  return {
    ...(typeof pagina === 'string' && pagina !== '' ? { pagina } : {}),
    ...(imprimir === true || imprimir === 'true' || imprimir === 1 || imprimir === '1'
      ? { imprimir: true }
      : {}),
  };
}
